module.exports = __webpack_public_path__ + "img/set_copripiumino_flying.0355e621.jpg";